module.exports = __webpack_public_path__ + "media/brands/junak-e31da914.png";